import { createSelector } from 'reselect'
import { get } from 'lodash'
import { RootState } from '../types'

export const requestIntroducerStatus = (state: RootState): RootState['introducer']['status'] => state.introducer.status
export const requestIntroducerCanUpdateUserDetailsSelector = (
  state: RootState,
): RootState['introducer']['canUpdateUserDetails'] => state.introducer.canUpdateUserDetails

export const getReferredUsersLoadingState = (state: RootState): RootState['introducer']['referredUsers']['status'] =>
  state.introducer.referredUsers.status

export const referredUsersIsLoading = createSelector(
  getReferredUsersLoadingState,
  (state): boolean => state === 'LOADING',
)

export const getReferredUsersData = (state: RootState): RootState['introducer']['referredUsers']['data'] =>
  state.introducer.referredUsers.data
export const getFormattedReferredUsersData = createSelector(getReferredUsersData, ({ items, meta }) => ({
  items: items.map((item) => ({
    name: item.referredUser.name,
    dateReferred: new Date(item.createdAt).toLocaleDateString(),
    dateApproved: '-',
    status: get(item, 'referredUser.sumsub.kycStatus', '-'),
  })),
  meta,
}))
export const getReferredUsersError = (state: RootState): RootState['introducer']['referredUsers']['error'] =>
  state.introducer.referredUsers.error
